import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import { Alert, Button } from 'reactstrap'

class BookPrint extends Component {
  render() {
    const { doc, error, isGeneratingPdf, } = this.props

    return (
      <div>
        {doc && !isGeneratingPdf &&
          <iframe
            src={'data:application/pdf;base64,' + doc}
            style={{width: '100%', height: '95vh'}}
          />
        }
        <BeatLoader loading={isGeneratingPdf} />
        {error &&
          <Alert>
            {error === 'permission'
              ? "Sorry, you don't have permission to access this book."
              : 'Error generating book. Please try again later.'
            }
          </Alert>
        }
      </div>
    )
  }
}

BookPrint.propTypes = {
  userAssessment: PropTypes.object,
  nodes: PropTypes.object,
  doc: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  isGeneratingPdf: PropTypes.bool.isRequired,
}

export default BookPrint


// WEBPACK FOOTER //
// ./src/components/BookPrint/BookPrint.js